import { useEffect } from 'react';
import classNames from 'classnames';
import ChoiceModel from './ChoiceModel';
import ChoiceStructure from './ChoiceStructure';
import ChoiceTopModel from './ChoiceTopModel';
import ChoiceBottomModel from './ChoiceBottomModel';
import ChoiceValance from './ChoiceValance';
import ChoiceFringe from './ChoiceFringe';
import ChoiceTopColor from './ChoiceTopColor';

function ChoiceDistributor({
	items,
	currentStep, setCurrentStep,
	model, setModel,
	setAllSteps,
	selectedData, setSelectedData,
	modelTop, setModelTop,
	modelValance, setModelValance,
	modelFringe, setModelFringe,
	setModelBottom,
	mainTitles, setMainTitles,
	modelTopColor, setModelTopColor
}) {
	let choiceIndex = 1

	const incrementIndex = () => {
		choiceIndex++;
	};

	useEffect(() => {
		setAllSteps(choiceIndex)
	});
	
	
	return (
		<>
			<div className={classNames('choice-holder', { 'is-visible': currentStep === choiceIndex })}>
				<ChoiceModel
					items={items}
					setSelectedData={setSelectedData}
					setModel={setModel}
					setModelTop={setModelTop}
					setModelTopColor={setModelTopColor}
					setModelBottom={setModelBottom}
				/>
				{incrementIndex()}
			</div>

			{!!Object.keys(window.loadedObjects).length && (
				<>
					<div className={classNames('choice-holder', { 'is-visible': currentStep === choiceIndex })}>
						<ChoiceTopModel
							selectedData={selectedData}
							setModelTop={setModelTop}
							setModelValance={setModelValance}
							mainTitles={mainTitles}
							setMainTitles={setMainTitles}
							setModelFringe={setModelFringe}
						/>
						{incrementIndex()}
					</div>

					{!!modelTop.valance && (
						<div className={classNames('choice-holder', { 'is-visible': currentStep === choiceIndex })}>
							<ChoiceValance
								modelTop={modelTop}
								setModelValance={setModelValance}
								setModelFringe={setModelFringe}
							/>
							{incrementIndex()}
						</div>
					)}

					{!!modelValance.fringe && (
						<div className={classNames('choice-holder', { 'is-visible': currentStep === choiceIndex })}>
							<ChoiceFringe
								modelTop={modelTop}
								modelValance={modelValance}
								modelFringe={modelFringe}
								setModelFringe={setModelFringe}
							/>
							{incrementIndex()}
						</div>
					)}

					<div className={classNames('choice-holder', { 'is-visible': currentStep === choiceIndex })}>
						<ChoiceTopColor
							selectedData={selectedData}
							model={model}
							setModel={setModel}
							modelTop={modelTop}
							modelTopColor={modelTopColor}
							setModelTopColor={setModelTopColor}
						/>
						{incrementIndex()}
					</div>

					<div className={classNames('choice-holder', { 'is-visible': currentStep === choiceIndex })}>
						<ChoiceStructure
							selectedData={selectedData}
							model={model}
							setModel={setModel}
						/>
						{incrementIndex()}
					</div>

					<div className={classNames('choice-holder', { 'is-visible': currentStep === choiceIndex })}>
						<ChoiceBottomModel
							selectedData={selectedData}
							setModelBottom={setModelBottom}
						/>
					</div>
				</>
			)}
		</>
	);
}

export default ChoiceDistributor;